{
    "戊辰": [
        {
            "干支组合": "子未寅",
            "格局": "涉害"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "寅亥申",
            "格局": "元首"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "比用"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "寅午午",
            "格局": "别责"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "亥寅巳",
            "格局": "遥克"
        },
        {
            "干支组合": "子辰申",
            "格局": "遥克"
        },
        {
            "干支组合": "寅未子",
            "格局": "重审"
        },
        {
            "干支组合": "亥巳亥",
            "格局": "反吟"
        }
    ],
    "戊寅": [
        {
            "干支组合": "子未寅",
            "格局": "重审"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "寅亥申",
            "格局": "元首"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "辰午申",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "丑午酉",
            "格局": "昴星"
        },
        {
            "干支组合": "子巳戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        }
    ],
    "戊子": [
        {
            "干支组合": "子未寅",
            "格局": "重审"
        },
        {
            "干支组合": "巳申丑",
            "格局": "昴星"
        },
        {
            "干支组合": "寅亥申",
            "格局": "涉害"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "戌酉申",
            "格局": "比用"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "寅卯辰",
            "格局": "比用"
        },
        {
            "干支组合": "辰午申",
            "格局": "重审"
        },
        {
            "干支组合": "卯午酉",
            "格局": "遥克"
        },
        {
            "干支组合": "辰申子",
            "格局": "元首"
        },
        {
            "干支组合": "巳戌卯",
            "格局": "重审"
        },
        {
            "干支组合": "午子午",
            "格局": "反吟"
        }
    ],
    "戊戌": [
        {
            "干支组合": "子未寅",
            "格局": "重审"
        },
        {
            "干支组合": "寅戌午",
            "格局": "遥克"
        },
        {
            "干支组合": "寅亥申",
            "格局": "元首"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥子丑",
            "格局": "重审"
        },
        {
            "干支组合": "子寅辰",
            "格局": "重审"
        },
        {
            "干支组合": "亥寅巳",
            "格局": "遥克"
        },
        {
            "干支组合": "寅午戌",
            "格局": "元首"
        },
        {
            "干支组合": "申丑午",
            "格局": "比用"
        },
        {
            "干支组合": "亥巳亥",
            "格局": "反吟"
        }
    ],
    "戊申": [
        {
            "干支组合": "子未寅",
            "格局": "涉害"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "寅亥申",
            "格局": "比用"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "戌酉午",
            "格局": "昴星"
        },
        {
            "干支组合": "子寅辰",
            "格局": "重审"
        },
        {
            "干支组合": "寅巳申",
            "格局": "遥克"
        },
        {
            "干支组合": "辰申子",
            "格局": "元首"
        },
        {
            "干支组合": "卯申丑",
            "格局": "元首"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        }
    ],
    "戊午": [
        {
            "干支组合": "子未寅",
            "格局": "重审"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "寅亥申",
            "格局": "元首"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "寅午午",
            "格局": "别责"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "酉子卯",
            "格局": "重审"
        },
        {
            "干支组合": "寅午戌",
            "格局": "元首"
        },
        {
            "干支组合": "辰酉寅",
            "格局": "比用"
        },
        {
            "干支组合": "午子午",
            "格局": "反吟"
        }
    ],
    "己巳": [
        {
            "干支组合": "巳戌卯",
            "格局": "比用"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "酉辰亥",
            "格局": "涉害"
        },
        {
            "干支组合": "卯亥未",
            "格局": "元首"
        },
        {
            "干支组合": "寅亥申",
            "格局": "遥克"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "申申午",
            "格局": "昴星"
        },
        {
            "干支组合": "亥丑卯",
            "格局": "遥克"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "涉害"
        }
    ],
    "己卯": [
        {
            "干支组合": "巳戌卯",
            "格局": "比用"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "反吟"
        },
        {
            "干支组合": "戌巳子",
            "格局": "重审"
        },
        {
            "干支组合": "未卯亥",
            "格局": "涉害"
        },
        {
            "干支组合": "子酉午",
            "格局": "遥克"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "涉害"
        },
        {
            "干支组合": "丑子亥",
            "格局": "重审"
        },
        {
            "干支组合": "卯子午",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "亥丑卯",
            "格局": "遥克"
        },
        {
            "干支组合": "酉子卯",
            "格局": "重审"
        },
        {
            "干支组合": "未亥卯",
            "格局": "涉害"
        }
    ],
    "己丑": [
        {
            "干支组合": "巳戌卯",
            "格局": "比用"
        },
        {
            "干支组合": "亥未丑",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "重审"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "涉害"
        },
        {
            "干支组合": "子辰戌",
            "格局": "昴星"
        },
        {
            "干支组合": "亥酉未",
            "格局": "重审"
        },
        {
            "干支组合": "子亥戌",
            "格局": "元首"
        },
        {
            "干支组合": "丑戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "寅卯辰",
            "格局": "元首"
        },
        {
            "干支组合": "卯巳未",
            "格局": "元首"
        },
        {
            "干支组合": "午戌辰",
            "格局": "昴星"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "涉害"
        }
    ],
    "己亥": [
        {
            "干支组合": "巳戌卯",
            "格局": "比用"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        },
        {
            "干支组合": "未卯亥",
            "格局": "涉害"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "卯丑亥",
            "格局": "遥克"
        },
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "亥未丑",
            "格局": "伏吟"
        },
        {
            "干支组合": "丑寅卯",
            "格局": "元首"
        },
        {
            "干支组合": "丑卯巳",
            "格局": "涉害"
        },
        {
            "干支组合": "寅巳申",
            "格局": "遥克"
        },
        {
            "干支组合": "亥卯未",
            "格局": "涉害"
        }
    ],
    "己酉": [
        {
            "干支组合": "未子巳",
            "格局": "涉害"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "反吟"
        },
        {
            "干支组合": "亥午丑",
            "格局": "重审"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "涉害"
        },
        {
            "干支组合": "午卯子",
            "格局": "元首"
        },
        {
            "干支组合": "卯丑亥",
            "格局": "遥克"
        },
        {
            "干支组合": "戌午申",
            "格局": "昴星"
        },
        {
            "干支组合": "酉未丑",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥子丑",
            "格局": "重审"
        },
        {
            "干支组合": "丑卯巳",
            "格局": "元首"
        },
        {
            "干支组合": "卯午酉",
            "格局": "遥克"
        },
        {
            "干支组合": "亥卯未",
            "格局": "重审"
        }
    ],
    "己未": [
        {
            "干支组合": "巳戌卯",
            "格局": "比用"
        },
        {
            "干支组合": "巳丑丑",
            "格局": "反吟"
        },
        {
            "干支组合": "酉辰亥",
            "格局": "比用"
        },
        {
            "干支组合": "卯亥未",
            "格局": "元首"
        },
        {
            "干支组合": "亥辰辰",
            "格局": "八专"
        },
        {
            "干支组合": "丑巳巳",
            "格局": "八专"
        },
        {
            "干支组合": "卯午午",
            "格局": "八专"
        },
        {
            "干支组合": "未丑戌",
            "格局": "伏吟"
        },
        {
            "干支组合": "未申申",
            "格局": "八专"
        },
        {
            "干支组合": "酉酉酉",
            "格局": "八专"
        },
        {
            "干支组合": "亥戌戌",
            "格局": "八专"
        },
        {
            "干支组合": "亥卯未",
            "格局": "重审"
        }
    ],
    "丙寅": [
        {
            "干支组合": "子未寅",
            "格局": "比用"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "亥申巳",
            "格局": "遥克"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "辰午申",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        },
        {
            "干支组合": "子巳戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        }
    ],
    "丙子": [
        {
            "干支组合": "子未寅",
            "格局": "涉害"
        },
        {
            "干支组合": "申辰子",
            "格局": "遥克"
        },
        {
            "干支组合": "午卯子",
            "格局": "元首"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "戌酉申",
            "格局": "知一"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "寅卯辰",
            "格局": "比用"
        },
        {
            "干支组合": "辰午申",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        },
        {
            "干支组合": "巳戌卯",
            "格局": "重审"
        },
        {
            "干支组合": "午子午",
            "格局": "反吟"
        }
    ],
    "丙戌": [
        {
            "干支组合": "子未寅",
            "格局": "比用"
        },
        {
            "干支组合": "酉巳丑",
            "格局": "遥克"
        },
        {
            "干支组合": "亥申巳",
            "格局": "遥克"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥子丑",
            "格局": "重审"
        },
        {
            "干支组合": "子寅辰",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        },
        {
            "干支组合": "申丑午",
            "格局": "知一"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        }
    ],
    "丙申": [
        {
            "干支组合": "戌巳子",
            "格局": "比用"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "酉戌亥",
            "格局": "遥克"
        },
        {
            "干支组合": "子寅辰",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        },
        {
            "干支组合": "卯申丑",
            "格局": "元首"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        }
    ],
    "丙午": [
        {
            "干支组合": "子未寅",
            "格局": "比用"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "子酉午",
            "格局": "遥克"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "申酉戌",
            "格局": "遥克"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "比用"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        },
        {
            "干支组合": "辰酉寅",
            "格局": "比用"
        },
        {
            "干支组合": "午子午",
            "格局": "反吟"
        }
    ],
    "丙辰": [
        {
            "干支组合": "午丑申",
            "格局": "比用"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "亥申巳",
            "格局": "遥克"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥午午",
            "格局": "别责"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        },
        {
            "干支组合": "寅未子",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        }
    ],
    "丁卯": [
        {
            "干支组合": "巳戌卯",
            "格局": "重审"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "反吟"
        },
        {
            "干支组合": "戌巳子",
            "格局": "重审"
        },
        {
            "干支组合": "未卯亥",
            "格局": "元首"
        },
        {
            "干支组合": "子酉午",
            "格局": "遥克"
        },
        {
            "干支组合": "亥酉未",
            "格局": "涉害"
        },
        {
            "干支组合": "丑子亥",
            "格局": "重审"
        },
        {
            "干支组合": "卯子午",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "涉害"
        },
        {
            "干支组合": "酉亥丑",
            "格局": "重审"
        },
        {
            "干支组合": "酉子卯",
            "格局": "重审"
        },
        {
            "干支组合": "未亥卯",
            "格局": "重审"
        }
    ],
    "丁丑": [
        {
            "干支组合": "巳戌卯",
            "格局": "重审"
        },
        {
            "干支组合": "亥未丑",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "重审"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "元首"
        },
        {
            "干支组合": "子辰戌",
            "格局": "昴星"
        },
        {
            "干支组合": "亥酉未",
            "格局": "重审"
        },
        {
            "干支组合": "子亥戌",
            "格局": "重审"
        },
        {
            "干支组合": "丑戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "申酉戌",
            "格局": "重审"
        },
        {
            "干支组合": "酉亥丑",
            "格局": "重审"
        },
        {
            "干支组合": "午戌辰",
            "格局": "昴星"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        }
    ],
    "丁亥": [
        {
            "干支组合": "巳戌卯",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        },
        {
            "干支组合": "未卯亥",
            "格局": "涉害"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "酉未巳",
            "格局": "遥克"
        },
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "亥未丑",
            "格局": "伏吟"
        },
        {
            "干支组合": "申酉戌",
            "格局": "重审"
        },
        {
            "干支组合": "酉亥丑",
            "格局": "重审"
        },
        {
            "干支组合": "午戌寅",
            "格局": "昴星"
        },
        {
            "干支组合": "未亥卯",
            "格局": "重审"
        }
    ],
    "丁酉": [
        {
            "干支组合": "未子巳",
            "格局": "涉害"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "反吟"
        },
        {
            "干支组合": "亥午丑",
            "格局": "重审"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "元首"
        },
        {
            "干支组合": "午卯子",
            "格局": "元首"
        },
        {
            "干支组合": "丑巳巳",
            "格局": "别责"
        },
        {
            "干支组合": "申未午",
            "格局": "遥克"
        },
        {
            "干支组合": "酉未丑",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥子丑",
            "格局": "比用"
        },
        {
            "干支组合": "酉亥丑",
            "格局": "重审"
        },
        {
            "干支组合": "子卯午",
            "格局": "遥克"
        },
        {
            "干支组合": "亥卯未",
            "格局": "元首"
        }
    ],
    "丁未": [
        {
            "干支组合": "巳戌卯",
            "格局": "比用"
        },
        {
            "干支组合": "巳丑丑",
            "格局": "反吟"
        },
        {
            "干支组合": "酉辰亥",
            "格局": "比用"
        },
        {
            "干支组合": "卯亥未",
            "格局": "元首"
        },
        {
            "干支组合": "亥辰辰",
            "格局": "八专"
        },
        {
            "干支组合": "丑巳巳",
            "格局": "八专"
        },
        {
            "干支组合": "卯午午",
            "格局": "八专"
        },
        {
            "干支组合": "未丑戌",
            "格局": "伏吟"
        },
        {
            "干支组合": "申酉戌",
            "格局": "重审"
        },
        {
            "干支组合": "酉亥丑",
            "格局": "重审"
        },
        {
            "干支组合": "亥戌戌",
            "格局": "八专"
        },
        {
            "干支组合": "亥卯未",
            "格局": "重审"
        }
    ],
    "丁巳": [
        {
            "干支组合": "巳戌卯",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "酉辰亥",
            "格局": "涉害"
        },
        {
            "干支组合": "亥未卯",
            "格局": "遥克"
        },
        {
            "干支组合": "亥申巳",
            "格局": "遥克"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "申酉戌",
            "格局": "重审"
        },
        {
            "干支组合": "酉亥丑",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        }
    ],
    "庚午": [
        {
            "干支组合": "辰申子",
            "格局": "涉害"
        },
        {
            "干支组合": "辰酉寅",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "戌巳子",
            "格局": "比用"
        },
        {
            "干支组合": "戌午寅",
            "格局": "涉害"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "午辰寅",
            "格局": "涉害"
        },
        {
            "干支组合": "午巳辰",
            "格局": "遥克"
        },
        {
            "干支组合": "申寅巳",
            "格局": "伏吟"
        },
        {
            "干支组合": "戌未酉",
            "格局": "昴星"
        },
        {
            "干支组合": "申戌子",
            "格局": "涉害"
        },
        {
            "干支组合": "酉子卯",
            "格局": "重审"
        }
    ],
    "庚辰": [
        {
            "干支组合": "辰申子",
            "格局": "元首"
        },
        {
            "干支组合": "寅未子",
            "格局": "重审"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "涉害"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "午辰寅",
            "格局": "涉害"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "申寅巳",
            "格局": "伏吟"
        },
        {
            "干支组合": "午未申",
            "格局": "遥克"
        },
        {
            "干支组合": "申戌子",
            "格局": "涉害"
        },
        {
            "干支组合": "寅巳申",
            "格局": "遥克"
        }
    ],
    "庚寅": [
        {
            "干支组合": "辰申子",
            "格局": "元首"
        },
        {
            "干支组合": "子巳戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "戌巳子",
            "格局": "比用"
        },
        {
            "干支组合": "戌午寅",
            "格局": "涉害"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "午辰寅",
            "格局": "涉害"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "申寅巳",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "辰午申",
            "格局": "涉害"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        }
    ],
    "庚子": [
        {
            "干支组合": "辰申子",
            "格局": "元首"
        },
        {
            "干支组合": "巳戌卯",
            "格局": "重审"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "戌巳子",
            "格局": "比用"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "午卯子",
            "格局": "比用"
        },
        {
            "干支组合": "午辰寅",
            "格局": "涉害"
        },
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "申寅巳",
            "格局": "伏吟"
        },
        {
            "干支组合": "寅卯辰",
            "格局": "比用"
        },
        {
            "干支组合": "辰午申",
            "格局": "涉害"
        },
        {
            "干支组合": "午酉子",
            "格局": "遥克"
        }
    ],
    "庚戌": [
        {
            "干支组合": "辰申子",
            "格局": "涉害"
        },
        {
            "干支组合": "申丑午",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "戌巳子",
            "格局": "比用"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "午辰寅",
            "格局": "元首"
        },
        {
            "干支组合": "午巳辰",
            "格局": "遥克"
        },
        {
            "干支组合": "申寅巳",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥子丑",
            "格局": "重审"
        },
        {
            "干支组合": "子寅辰",
            "格局": "重审"
        },
        {
            "干支组合": "寅巳申",
            "格局": "遥克"
        }
    ],
    "庚申": [
        {
            "干支组合": "辰申子",
            "格局": "元首"
        },
        {
            "干支组合": "卯丑丑",
            "格局": "八专"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "戌巳子",
            "格局": "比用"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "午辰寅",
            "格局": "元首"
        },
        {
            "干支组合": "酉未未",
            "格局": "八专"
        },
        {
            "干支组合": "申寅巳",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥酉酉",
            "格局": "八专"
        },
        {
            "干支组合": "子寅辰",
            "格局": "重审"
        },
        {
            "干支组合": "丑亥亥",
            "格局": "八专"
        }
    ],
    "辛未": [
        {
            "干支组合": "寅辰午",
            "格局": "遥克"
        },
        {
            "干支组合": "亥丑丑",
            "格局": "别责"
        },
        {
            "干支组合": "亥卯未",
            "格局": "比用"
        },
        {
            "干支组合": "巳戌卯",
            "格局": "涉害"
        },
        {
            "干支组合": "巳丑辰",
            "格局": "反吟"
        },
        {
            "干支组合": "酉辰亥",
            "格局": "涉害"
        },
        {
            "干支组合": "卯亥未",
            "格局": "比用"
        },
        {
            "干支组合": "亥未未",
            "格局": "别责"
        },
        {
            "干支组合": "午辰寅",
            "格局": "元首"
        },
        {
            "干支组合": "巳辰卯",
            "格局": "遥克"
        },
        {
            "干支组合": "未丑戌",
            "格局": "伏吟"
        },
        {
            "干支组合": "申亥申",
            "格局": "昴星"
        }
    ],
    "辛巳": [
        {
            "干支组合": "寅辰午",
            "格局": "遥克"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "比用"
        },
        {
            "干支组合": "卯申丑",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "未寅酉",
            "格局": "涉害"
        },
        {
            "干支组合": "午寅戌",
            "格局": "元首"
        },
        {
            "干支组合": "寅亥申",
            "格局": "遥克"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "比用"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "巳申寅",
            "格局": "伏吟"
        },
        {
            "干支组合": "午未申",
            "格局": "遥克"
        }
    ],
    "辛卯": [
        {
            "干支组合": "巳未酉",
            "格局": "遥克"
        },
        {
            "干支组合": "酉子卯",
            "格局": "重审"
        },
        {
            "干支组合": "未亥卯",
            "格局": "涉害"
        },
        {
            "干支组合": "卯申丑",
            "格局": "重审"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "反吟"
        },
        {
            "干支组合": "戌巳子",
            "格局": "重审"
        },
        {
            "干支组合": "未卯亥",
            "格局": "比用"
        },
        {
            "干支组合": "子未子",
            "格局": "昴星"
        },
        {
            "干支组合": "亥酉未",
            "格局": "涉害"
        },
        {
            "干支组合": "丑子亥",
            "格局": "重审"
        },
        {
            "干支组合": "卯子午",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        }
    ],
    "辛丑": [
        {
            "干支组合": "卯巳未",
            "格局": "元首"
        },
        {
            "干支组合": "巳丑丑",
            "格局": "别责"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "比用"
        },
        {
            "干支组合": "卯申丑",
            "格局": "重审"
        },
        {
            "干支组合": "亥未辰",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "重审"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "比用"
        },
        {
            "干支组合": "巳未未",
            "格局": "别责"
        },
        {
            "干支组合": "亥酉未",
            "格局": "重审"
        },
        {
            "干支组合": "子亥戌",
            "格局": "重审"
        },
        {
            "干支组合": "丑戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "寅卯辰",
            "格局": "元首"
        }
    ],
    "辛亥": [
        {
            "干支组合": "丑卯巳",
            "格局": "涉害"
        },
        {
            "干支组合": "巳申亥",
            "格局": "遥克"
        },
        {
            "干支组合": "未亥卯",
            "格局": "比用"
        },
        {
            "干支组合": "卯申丑",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        },
        {
            "干支组合": "未卯亥",
            "格局": "涉害"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "午辰寅",
            "格局": "元首"
        },
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "亥戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "丑寅卯",
            "格局": "元首"
        }
    ],
    "辛酉": [
        {
            "干支组合": "丑卯巳",
            "格局": "元首"
        },
        {
            "干支组合": "卯午酉",
            "格局": "遥克"
        },
        {
            "干支组合": "寅午戌",
            "格局": "重审"
        },
        {
            "干支组合": "未子巳",
            "格局": "涉害"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "反吟"
        },
        {
            "干支组合": "亥午丑",
            "格局": "重审"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "比用"
        },
        {
            "干支组合": "午卯子",
            "格局": "元首"
        },
        {
            "干支组合": "午辰寅",
            "格局": "元首"
        },
        {
            "干支组合": "丑酉酉",
            "格局": "别责"
        },
        {
            "干支组合": "酉戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥子丑",
            "格局": "重审"
        }
    ],
    "甲子": [
        {
            "干支组合": "戌申午",
            "格局": "元首"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅巳申",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "辰午申",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "辰申子",
            "格局": "元首"
        },
        {
            "干支组合": "子巳戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "寅酉辰",
            "格局": "比用"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "午卯子",
            "格局": "元首"
        }
    ],
    "甲戌": [
        {
            "干支组合": "午辰寅",
            "格局": "涉害"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅巳申",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "比用"
        },
        {
            "干支组合": "辰午申",
            "格局": "涉害"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "寅午戌",
            "格局": "元首"
        },
        {
            "干支组合": "子巳戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "子未寅",
            "格局": "比用"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "申巳寅",
            "格局": "遥克"
        }
    ],
    "甲申": [
        {
            "干支组合": "午辰寅",
            "格局": "涉害"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅巳申",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "辰午申",
            "格局": "涉害"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "辰申子",
            "格局": "元首"
        },
        {
            "干支组合": "子巳戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "戌巳子",
            "格局": "比用"
        },
        {
            "干支组合": "戌午寅",
            "格局": "涉害"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        }
    ],
    "甲午": [
        {
            "干支组合": "戌申午",
            "格局": "涉害"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅巳申",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "辰午申",
            "格局": "涉害"
        },
        {
            "干支组合": "申亥寅",
            "格局": "比用"
        },
        {
            "干支组合": "寅午戌",
            "格局": "元首"
        },
        {
            "干支组合": "子巳戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "酉辰亥",
            "格局": "元首"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "申巳寅",
            "格局": "遥克"
        }
    ],
    "甲辰": [
        {
            "干支组合": "戌申午",
            "格局": "涉害"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅巳申",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "辰午申",
            "格局": "涉害"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "申子辰",
            "格局": "遥克"
        },
        {
            "干支组合": "寅未子",
            "格局": "涉害"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "比用"
        },
        {
            "干支组合": "戌午寅",
            "格局": "涉害"
        },
        {
            "干支组合": "申巳寅",
            "格局": "遥克"
        }
    ],
    "甲寅": [
        {
            "干支组合": "戌申午",
            "格局": "元首"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅巳申",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "辰午申",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "申午午",
            "格局": "八专"
        },
        {
            "干支组合": "子巳戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "酉辰亥",
            "格局": "元首"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "丑亥亥",
            "格局": "八专"
        }
    ],
    "乙丑": [
        {
            "干支组合": "巳丑酉",
            "格局": "元首"
        },
        {
            "干支组合": "丑戌未",
            "格局": "重审"
        },
        {
            "干支组合": "亥酉未",
            "格局": "重审"
        },
        {
            "干支组合": "子亥戌",
            "格局": "重审"
        },
        {
            "干支组合": "辰丑戌",
            "格局": "伏吟"
        },
        {
            "干支组合": "寅卯辰",
            "格局": "元首"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "未戌丑",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        },
        {
            "干支组合": "寅未子",
            "格局": "重审"
        },
        {
            "干支组合": "戌辰戌",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "比用"
        }
    ],
    "乙亥": [
        {
            "干支组合": "未卯亥",
            "格局": "涉害"
        },
        {
            "干支组合": "丑戌未",
            "格局": "重审"
        },
        {
            "干支组合": "酉未巳",
            "格局": "遥克"
        },
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "辰亥巳",
            "格局": "伏吟"
        },
        {
            "干支组合": "丑寅卯",
            "格局": "元首"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "未戌丑",
            "格局": "重审"
        },
        {
            "干支组合": "未亥卯",
            "格局": "重审"
        },
        {
            "干支组合": "寅未子",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        }
    ],
    "乙酉": [
        {
            "干支组合": "巳丑酉",
            "格局": "元首"
        },
        {
            "干支组合": "丑戌未",
            "格局": "重审"
        },
        {
            "干支组合": "未巳卯",
            "格局": "遥克"
        },
        {
            "干支组合": "申未午",
            "格局": "遥克"
        },
        {
            "干支组合": "辰酉卯",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥子丑",
            "格局": "重审"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "未戌丑",
            "格局": "重审"
        },
        {
            "干支组合": "申子辰",
            "格局": "元首"
        },
        {
            "干支组合": "未子巳",
            "格局": "比用"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "涉害"
        },
        {
            "干支组合": "亥午丑",
            "格局": "比用"
        }
    ],
    "乙未": [
        {
            "干支组合": "卯亥未",
            "格局": "元首"
        },
        {
            "干支组合": "丑戌未",
            "格局": "重审"
        },
        {
            "干支组合": "亥寅巳",
            "格局": "昴星"
        },
        {
            "干支组合": "戌卯午",
            "格局": "昴星"
        },
        {
            "干支组合": "辰未丑",
            "格局": "伏吟"
        },
        {
            "干支组合": "酉戌亥",
            "格局": "遥克"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "未戌丑",
            "格局": "重审"
        },
        {
            "干支组合": "亥卯未",
            "格局": "重审"
        },
        {
            "干支组合": "巳戌卯",
            "格局": "比用"
        },
        {
            "干支组合": "戌辰戌",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        }
    ],
    "乙巳": [
        {
            "干支组合": "酉巳丑",
            "格局": "遥克"
        },
        {
            "干支组合": "丑戌未",
            "格局": "重审"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        },
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "辰巳申",
            "格局": "伏吟"
        },
        {
            "干支组合": "未申酉",
            "格局": "遥克"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "未戌丑",
            "格局": "比用"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "重审"
        },
        {
            "干支组合": "寅未子",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        }
    ],
    "乙卯": [
        {
            "干支组合": "未卯亥",
            "格局": "元首"
        },
        {
            "干支组合": "丑戌未",
            "格局": "重审"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "涉害"
        },
        {
            "干支组合": "丑子亥",
            "格局": "重审"
        },
        {
            "干支组合": "辰卯子",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "酉子卯",
            "格局": "涉害"
        },
        {
            "干支组合": "未亥卯",
            "格局": "涉害"
        },
        {
            "干支组合": "寅未子",
            "格局": "重审"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "涉害"
        }
    ],
    "壬申": [
        {
            "干支组合": "丑寅卯",
            "格局": "元首"
        },
        {
            "干支组合": "子寅辰",
            "格局": "重审"
        },
        {
            "干支组合": "巳申亥",
            "格局": "遥克"
        },
        {
            "干支组合": "未亥卯",
            "格局": "重审"
        },
        {
            "干支组合": "辰酉寅",
            "格局": "元首"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "涉害"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "午辰寅",
            "格局": "元首"
        },
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "亥申寅",
            "格局": "伏吟"
        }
    ],
    "壬午": [
        {
            "干支组合": "丑寅卯",
            "格局": "元首"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "酉子卯",
            "格局": "重审"
        },
        {
            "干支组合": "未亥卯",
            "格局": "重审"
        },
        {
            "干支组合": "辰酉寅",
            "格局": "比用"
        },
        {
            "干支组合": "午子午",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "寅子戌",
            "格局": "元首"
        },
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "亥午子",
            "格局": "伏吟"
        }
    ],
    "壬辰": [
        {
            "干支组合": "丑寅卯",
            "格局": "元首"
        },
        {
            "干支组合": "申戌子",
            "格局": "重审"
        },
        {
            "干支组合": "戌丑辰",
            "格局": "遥克"
        },
        {
            "干支组合": "未亥卯",
            "格局": "重审"
        },
        {
            "干支组合": "寅未子",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "比用"
        },
        {
            "干支组合": "子申辰",
            "格局": "重审"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "寅子戌",
            "格局": "元首"
        },
        {
            "干支组合": "戌酉申",
            "格局": "比用"
        },
        {
            "干支组合": "亥辰戌",
            "格局": "伏吟"
        }
    ],
    "壬寅": [
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "辰午申",
            "格局": "重审"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "未亥卯",
            "格局": "重审"
        },
        {
            "干支组合": "子巳戌",
            "格局": "比用"
        },
        {
            "干支组合": "寅申寅",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        },
        {
            "干支组合": "戌午寅",
            "格局": "重审"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "戌申午",
            "格局": "元首"
        },
        {
            "干支组合": "子亥戌",
            "格局": "比用"
        },
        {
            "干支组合": "亥寅巳",
            "格局": "伏吟"
        }
    ],
    "壬子": [
        {
            "干支组合": "寅卯辰",
            "格局": "比用"
        },
        {
            "干支组合": "辰午申",
            "格局": "重审"
        },
        {
            "干支组合": "午酉子",
            "格局": "遥克"
        },
        {
            "干支组合": "未亥卯",
            "格局": "重审"
        },
        {
            "干支组合": "巳戌卯",
            "格局": "重审"
        },
        {
            "干支组合": "午子午",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        },
        {
            "干支组合": "未卯亥",
            "格局": "涉害"
        },
        {
            "干支组合": "午卯子",
            "格局": "比用"
        },
        {
            "干支组合": "戌申午",
            "格局": "元首"
        },
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "亥子卯",
            "格局": "伏吟"
        }
    ],
    "壬戌": [
        {
            "干支组合": "亥子丑",
            "格局": "重审"
        },
        {
            "干支组合": "子寅辰",
            "格局": "重审"
        },
        {
            "干支组合": "辰未戌",
            "格局": "遥克"
        },
        {
            "干支组合": "未亥卯",
            "格局": "重审"
        },
        {
            "干支组合": "辰酉寅",
            "格局": "涉害"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "午丑申",
            "格局": "重审"
        },
        {
            "干支组合": "未卯亥",
            "格局": "涉害"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "元首"
        },
        {
            "干支组合": "午辰寅",
            "格局": "元首"
        },
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "亥戌未",
            "格局": "伏吟"
        }
    ],
    "癸酉": [
        {
            "干支组合": "未午巳",
            "格局": "遥克"
        },
        {
            "干支组合": "丑戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "亥子丑",
            "格局": "重审"
        },
        {
            "干支组合": "丑卯巳",
            "格局": "元首"
        },
        {
            "干支组合": "辰未戌",
            "格局": "元首"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "涉害"
        },
        {
            "干支组合": "未子巳",
            "格局": "比用"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "涉害"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "元首"
        },
        {
            "干支组合": "午卯子",
            "格局": "涉害"
        },
        {
            "干支组合": "未巳卯",
            "格局": "遥克"
        }
    ],
    "癸未": [
        {
            "干支组合": "巳辰卯",
            "格局": "遥克"
        },
        {
            "干支组合": "丑戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "申寅申",
            "格局": "昴星"
        },
        {
            "干支组合": "巳未酉",
            "格局": "遥克"
        },
        {
            "干支组合": "辰未戌",
            "格局": "元首"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "涉害"
        },
        {
            "干支组合": "巳戌卯",
            "格局": "比用"
        },
        {
            "干支组合": "未丑未",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "重审"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "涉害"
        },
        {
            "干支组合": "戌未辰",
            "格局": "元首"
        },
        {
            "干支组合": "巳卯丑",
            "格局": "遥克"
        }
    ],
    "癸巳": [
        {
            "干支组合": "卯寅丑",
            "格局": "元首"
        },
        {
            "干支组合": "丑戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "未申酉",
            "格局": "遥克"
        },
        {
            "干支组合": "未酉亥",
            "格局": "遥克"
        },
        {
            "干支组合": "申亥寅",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "涉害"
        },
        {
            "干支组合": "午亥辰",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "重审"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "元首"
        },
        {
            "干支组合": "戌未辰",
            "格局": "元首"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "重审"
        }
    ],
    "癸卯": [
        {
            "干支组合": "丑子亥",
            "格局": "重审"
        },
        {
            "干支组合": "丑戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "辰巳午",
            "格局": "重审"
        },
        {
            "干支组合": "未酉亥",
            "格局": "遥克"
        },
        {
            "干支组合": "酉子卯",
            "格局": "重审"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "涉害"
        },
        {
            "干支组合": "午亥辰",
            "格局": "重审"
        },
        {
            "干支组合": "卯酉卯",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "比用"
        },
        {
            "干支组合": "未卯亥",
            "格局": "涉害"
        },
        {
            "干支组合": "戌未辰",
            "格局": "元首"
        },
        {
            "干支组合": "丑亥酉",
            "格局": "涉害"
        }
    ],
    "癸丑": [
        {
            "干支组合": "子亥戌",
            "格局": "重审"
        },
        {
            "干支组合": "丑戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "寅卯辰",
            "格局": "元首"
        },
        {
            "干支组合": "卯巳未",
            "格局": "元首"
        },
        {
            "干支组合": "辰未戌",
            "格局": "元首"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "涉害"
        },
        {
            "干支组合": "午亥辰",
            "格局": "重审"
        },
        {
            "干支组合": "未丑未",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "重审"
        },
        {
            "干支组合": "巳丑酉",
            "格局": "元首"
        },
        {
            "干支组合": "戌未辰",
            "格局": "元首"
        },
        {
            "干支组合": "亥酉未",
            "格局": "重审"
        }
    ],
    "癸亥": [
        {
            "干支组合": "戌酉申",
            "格局": "元首"
        },
        {
            "干支组合": "丑戌未",
            "格局": "伏吟"
        },
        {
            "干支组合": "丑寅卯",
            "格局": "元首"
        },
        {
            "干支组合": "丑卯巳",
            "格局": "涉害"
        },
        {
            "干支组合": "辰未戌",
            "格局": "元首"
        },
        {
            "干支组合": "酉丑巳",
            "格局": "涉害"
        },
        {
            "干支组合": "午亥辰",
            "格局": "重审"
        },
        {
            "干支组合": "巳亥巳",
            "格局": "反吟"
        },
        {
            "干支组合": "卯戌巳",
            "格局": "比用"
        },
        {
            "干支组合": "未卯亥",
            "格局": "涉害"
        },
        {
            "干支组合": "巳寅亥",
            "格局": "比用"
        },
        {
            "干支组合": "未巳卯",
            "格局": "遥克"
        }
    ]
}